import { I18n } from '@calendly/i18n'

export const hasRoleInGroup = (member, role, userGroup) => {
  const scopedRelationships = member.user_group_relationships[userGroup.id]
  return scopedRelationships && !!scopedRelationships[role]
}

export const hasRoleInGroupWithTranslation = (member, role, userGroup) => {
  if (hasRoleInGroup(member, role, userGroup)) {
    return I18n.t('publisher.action.yes')
  }
  return I18n.t('publisher.action.no')
}
